import { useAuth } from '../../contexts/AuthContext';
import { formatDate } from '../../utils/format';

/* Onglet « Facturation » des paramètres — extrait tel quel de
 * AccountSettingsPage.tsx (markup/classes identiques). */

export default function BillingTabContent({
  currentPlan,
  planLabel,
  billingLoading,
  onOpenBillingPortal,
}: {
  currentPlan: string;
  planLabel: string;
  billingLoading: boolean;
  onOpenBillingPortal: () => void;
}) {
  const { organization } = useAuth();
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-slate-900">Facturation</h2>

      {/* Current plan */}
      <div className="bg-slate-50 rounded-lg p-4 space-y-3">
        <div>
          <p className="text-xs text-slate-500 mb-0.5">Plan actuel</p>
          <p className="text-sm font-semibold text-slate-900">
            {planLabel}
            {organization?.subscriptionStatus === 'active' && (
              <span className="ml-2 text-xs font-normal px-2 py-0.5 rounded-full bg-emerald-200 text-ink">
                Actif
              </span>
            )}
            {organization?.subscriptionStatus === 'past_due' && (
              <span className="ml-2 text-xs font-normal px-2 py-0.5 rounded-full bg-orange-200 text-ink">
                Paiement en retard
              </span>
            )}
          </p>
        </div>

        {organization?.currentPeriodEnd && (
          <div>
            <p className="text-xs text-slate-500 mb-0.5">Prochaine échéance</p>
            <p className="text-sm text-slate-900">
              {formatDate(organization.currentPeriodEnd)}
            </p>
          </div>
        )}

        {(organization?.creditBalance ?? 0) > 0 && (
          <div>
            <p className="text-xs text-slate-500 mb-0.5">Crédits à l'unité</p>
            <p className="text-sm font-medium text-slate-900">
              {organization!.creditBalance} crédit{organization!.creditBalance > 1 ? 's' : ''} restant{organization!.creditBalance > 1 ? 's' : ''}
            </p>
          </div>
        )}
      </div>

      {/* Stripe portal for paid plans (free/beta/partner = comp, pas d'abonnement) */}
      {currentPlan !== 'free' && currentPlan !== 'beta' && currentPlan !== 'partner' && (
        <div className="space-y-3">
          <p className="text-sm text-slate-600">
            Gérez votre abonnement, consultez vos factures ou mettez à jour votre moyen de paiement via le portail Stripe.
          </p>
          <button
            onClick={onOpenBillingPortal}
            disabled={billingLoading}
            className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-100 transition-colors disabled:opacity-50"
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
            </svg>
            {billingLoading ? 'Ouverture...' : 'Gérer l\'abonnement'}
          </button>
        </div>
      )}

      {/* Comp / no-subscription plans: no invoices */}
      {(currentPlan === 'free' || currentPlan === 'beta' || currentPlan === 'partner') && (
        <p className="text-sm text-slate-500">
          {currentPlan === 'beta'
            ? 'Accès Beta Partner — aucun abonnement actif.'
            : currentPlan === 'partner'
              ? 'Accès Partenaire — utilisation illimitée offerte, aucun abonnement.'
              : 'Aucune facture disponible.'}
        </p>
      )}
    </div>
  );
}
